/**
 * Dates object generated by Goal app.
 *
 * @typedef {Object} Dates
 * @namespace
 *
 * @memberof module:Goal.Model.Entity
 *
 * @property {Integer} start The date start timestamp.
 * @property {Integer} end The date end timestamp.
 * @property {String} startHuman Human readable version of the start timestamp.
 * @property {String} endHuman Human readable version of the end timestamp.
 */
class Dates {

	constructor(start, end, startHuman, endHuman) {

		this.start = start;
		this.end = end;
		this.startHuman = startHuman;
		this.endHuman = endHuman;
	}
}

export default Dates;